import clsx from 'clsx'
import { Icon } from '@iconify/react'

import { useGlobalState } from '@pepper/ui'

import styles from './_.module.css'

function DocUpdateStatus() {
  const { docErrorUpdate, editorUpdateStatus, editorNetworkState } =
    useGlobalState()

  if (editorNetworkState === 'OFFLINE') {
    return (
      <div className={clsx(styles.pill, styles.error)}>
        <Icon icon="lucide:cloud-off" fontSize={16} />
        No Connection
      </div>
    )
  } else if (docErrorUpdate) {
    return (
      <div className={clsx(styles.pill, styles.error)}>
        <Icon icon="lucide:cloud-off" width={16} height={16} />
        Update failed
      </div>
    )
  } else if (editorUpdateStatus === 'UPDATING') {
    return (
      <div className={styles.pill}>
        <Icon icon="lucide:upload-cloud" width={16} height={16} />
        Saving...
      </div>
    )
  } else if (editorUpdateStatus === 'UPDATED') {
    return (
      <div className={styles.pill}>
        <Icon icon="lucide:cloud" width={16} height={16} />
        Saved
      </div>
    )
  } else {
    return null
  }
}

export default DocUpdateStatus
